import { request } from "../../api/api"

export const getPrivacy = () => {
    return request.get("/privacy-policies/")
}


export const getPrivacyPolicies = () => {
    return request.get('/privacy-policies/');
};
export const updatePrivacyPolicy = (data) => {
    return request.post(`/privacy-policies/`,data);
};